import { Component, OnInit, ElementRef, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, HostListener, ViewChildren, ViewRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DatePipe } from "@angular/common";
import { TranslateService } from "@ngx-translate/core";
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MatMenuTrigger } from "@angular/material";
import { SelectionModel } from "@angular/cdk/collections";
import { CdkDragStart, CdkDropList, moveItemInArray } from "@angular/cdk/drag-drop";
// RXJS
import { debounceTime, distinctUntilChanged, tap } from "rxjs/operators";
import { ReplaySubject, fromEvent, merge, BehaviorSubject } from "rxjs";
//Datasource
import { TonKhoHienTaiDataSource } from "../ton-kho-hien-tai-datasource/ton-kho-hien-tai.datasource";
//Service
import { TonKhoHienTaiService } from "../ton-kho-hien-tai-service/ton-kho-hien-tai.service";
import { SubheaderService } from "../../../../../../core/_base/layout";
import { LayoutUtilsService, QueryParamsModel, MessageType } from "../../../../../../core/_base/crud";
import { environment } from "../../../../../../../environments/environment";
//Model
import { TonKhoHienTai, UpdateNoteQARequestBody, UpdateTagInfoRequestBody } from "../ton-kho-hien-tai-model/ton-kho-hien-tai.model";
import { DungChungService } from "../../../dung-chung/__services/dung-chung.service";
import { CommonConFig } from "../../../dung-chung/__model/common_config.model";

import { COMMA, ENTER, L } from "@angular/cdk/keycodes";
import { MatAutocompleteSelectedEvent, MatAutocomplete } from "@angular/material";
import moment from "moment";
import { FunctionPublic } from "../../../dung-chung/__function/common_function";
import { TonKhoHienTaiHistoriesComponent } from "../ton-kho-hien-tai-histories/ton-kho-hien-tai-histories.component";
import { TonKhoHienTaiPopUpComponent } from "../ton-kho-hien-tai-popup/ton-kho-hien-tai-popup.component";

@Component({
	selector: "m-ton-kho-hien-tai-list",
	templateUrl: "./ton-kho-hien-tai-list.component.html",
	styleUrls: ["../ton-kho-hien-tai.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe],
})
export class TonKhoHienTaiListComponent implements OnInit {
	CONFIG: CommonConFig;
	// Table fields
	dataSource: TonKhoHienTaiDataSource;
	displayedColumns = [];
	availableColumns = [
		{
			stt: 1,
			name: "#",
			displayName: "#",
			alwaysChecked: false,
			isShow: true,
		},

		{
			stt: 2,
			name: "TenKho",
			displayName: "Kho",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 3,
			name: "MaHH",
			displayName: "Mã hàng",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 4,
			name: "TenHH",
			displayName: "Tên hàng",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 5,
			name: "Solo",
			displayName: "Số lô",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 8,
			name: "Ngaynhapkho",
			displayName: "Ngày nhập kho",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 6,
			name: "Soluong",
			displayName: "SL tồn",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 7,
			name: "TenDVT",
			displayName: "ĐVT",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 8,
			name: "SoMay",
			displayName: "Số máy",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 8,
			name: "SoXeSoMe",
			displayName: "Số mẻ/số xe",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 8,
			name: "MaThung",
			displayName: "Mã thùng",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 8,
			name: "MaSub",
			displayName: "Mã sub lô",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 9,
			name: "ViTriKho",
			displayName: "Vị trí lưu kho",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 10,
			name: "PalletText",
			displayName: "PalletText",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 10,
			name: "Tag",
			displayName: "Tags",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 10,
			name: "GhiChu",
			displayName: "Ghi chú QA",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 10,
			name: "GhiChuDNNK",
			displayName: "Ghi chú ",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 11,
			name: "HSD",
			displayName: "Hạn sử dụng",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 11,
			name: "NSX",
			displayName: "Ngày sản xuất",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 11,
			name: "NgayDongThung",
			displayName: "Ngày đóng thùng",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 11,
			name: "NgayNhanHang",
			displayName: "Ngày nhận hàng từ NCC",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 11,
			name: "MaNCC",
			displayName: "Mã nhà cung cấp",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 11,
			name: "TenNCC",
			displayName: "Tên nhà cung cấp",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 12,
			name: "TenNHH",
			displayName: "Nhóm hàng",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 13,
			name: "TenLoaiHH",
			displayName: "Loại hàng",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 14,
			name: "SoPhieu",
			displayName: "Mã ĐHB",
			alwaysChecked: false,
			isShow: true,
		},
    {
			stt: 15,
			name: "RemainDatePercentage",
			displayName: "% Date còn tồn",
			alwaysChecked: false,
			isShow: true,
		},
		// {
		//     stt: 15,
		//     name: 'Tinhtrang',
		//     displayName: 'Tình trạng',
		//     alwaysChecked: false,
		// 	isShow: true
		// },

		// {
		//     stt: 16,
		//     name: 'LyDoKhongDuocXuat',
		//     displayName: 'Lý do không được xuất',
		//     alwaysChecked: false,
		// 	isShow: true
		// },
	];
	sumColums: string[] = ["#", "Soluong"];

	@ViewChildren("focus") focus;
	@ViewChildren("HH") HH;
	@ViewChild("sort1", { static: true }) sort: MatSort;
	@ViewChild("trigger", { static: true }) _trigger: MatMenuTrigger;
	@ViewChild("keywordSearch", { static: true }) keywordSearch: ElementRef;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	SHOW_BUTTON_SAVE = new BehaviorSubject<boolean>(false);
	SHOW_BUTTON_EDIT_GHICHU = new BehaviorSubject<boolean>(false);

	screenHeight: any;
	// Selection
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<TonKhoHienTai>(true, []);

	tmpTonKhoHienTaiResult: TonKhoHienTai[] = [];
	fullTonKhoHienTaiResult: TonKhoHienTai[] = [];

	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();

	listId_HH: any[] = [];
	selectId_HH: string[] = [];
	filteredId_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_HHFilterCtrl: string = "";
	haveElementId_HH: boolean = false;

	listKho: any[] = [];
	selectKho: string[] = [];
	filteredKho: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	KhoFilterCtrl: string = "";
	haveElementKho: boolean = false;

	// Filter loại hàng hóa
	listLoaiHH: any[] = [];
	selectLoaiHH: string[] = [];
	filteredLoaiHH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	LoaiHHFilterCtrl: string = "";
	haveElementLoaiHH: boolean = false;

	previousIndex: number;
	fixedPoint = 2;
	isClearAll: boolean = false;

	//ROLES
	LIST_ROLES_USER: [] = [];
	MODIFY_INVENTORY_TAGS = TonKhoHienTai.MODIFY_INVENTORY_TAGS;
	MODIFY_INVENTORY_NOTE_QA = TonKhoHienTai.MODIFY_INVENTORY_NOTE_QA;
	EDIT_GHICHU = "1541";
	//filter on grid
	haveFilter: boolean = false;
	filterGroupDataChecked: any = {};
	filterGroupDataCheckedFake: any = {};
	filterGroupData: any = {};
	filterGroupArray: any = {};
	filterText: any = {};
	tmpfilterText: any = {};
	disableButtonFilter: any = {};

	// Filter kho
	listIdKho: any[] = [];
	selectIdKho: string[] = [];
	filteredIdKho: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	IdKhoFilterCtrl: string = "";
	haveElementIdKho: boolean = false;
	// Filter hàng hóa
	listIdHH: any[] = [];
	selectIdHH: string[] = [];
	filteredIdHH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	IdHHFilterCtrl: string = "";
	haveElementIdHH: boolean = false;
	isShow: boolean = true;
	isShowSpinner = new BehaviorSubject<boolean>(false);
	isLoadMoreSpinner = new BehaviorSubject<boolean>(false);
	isExportExcel = new BehaviorSubject<boolean>(false);
	selectNonZeroWeight: boolean = false;
	/*------------------------- Support tags: ----------------------------*/
	@ViewChild("tagInput", { static: false }) tagInput: ElementRef<HTMLInputElement>;
	@ViewChild("auto", { static: false }) matAutocomplete: MatAutocomplete;

	separatorKeysCodes: number[] = [ENTER, COMMA];
	filteredTags: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	selectedTag: string[] = [];
	listTag: string[] = [];
	down: Date;
	top: Date;
	MAX_RECORD = 100;
	CURRENT_PAGE = 1;
	PREV_PAGE = 0;
	loadingWidth = new BehaviorSubject<string>("");
	loadDropdownProduct = new BehaviorSubject<boolean>(false);
	@ViewChild("listContainer", { static: false }) listContainer: ElementRef<HTMLInputElement>;
	/* ------------------------------------------------------------------ */
	/*------------------------- List tags: ----------------------------*/
	listTagFull: any[] = [];
	isCopyTag: boolean = TonKhoHienTai.COPYTAG.FALSE;
	dataCopyTag: string[] = [];
	positionInvPasteTag: number[] = [];
	isCheckedAll: boolean = false;
	processSaveTag = new BehaviorSubject<boolean>(false);
	codeCopyTag = TonKhoHienTai.POPUP_MULTIPLE[TonKhoHienTai.INDEX_TAG].Code;
	/* ------------------------------------------------------------------ */
	/*------------------------- List ghi chú QA: ----------------------------*/
	isCopyNoteQA: boolean = TonKhoHienTai.COPYNOTEQA.FALSE;
	dataCopyNoteQA: string = "";
	positionInvPasteNoteQA: number[] = [];
	processSaveNoteQA = new BehaviorSubject<boolean>(false);
	codeCopyNoteQA = TonKhoHienTai.POPUP_MULTIPLE[TonKhoHienTai.INDEX_NOTE_QA].Code;
	/* ------------------------------------------------------------------ */
	permissionsSubject = new BehaviorSubject<{ [key: string]: boolean }>({});

	constructor(private tonKhoHienTaiService: TonKhoHienTaiService, public dialog: MatDialog, private route: ActivatedRoute, private router: Router, private datePipe: DatePipe, private translate: TranslateService, private subheaderService: SubheaderService, private dungChungService: DungChungService, private changeDetect: ChangeDetectorRef, private layoutUtilsService: LayoutUtilsService) {
		let user = JSON.parse(localStorage.getItem("UserInfo"));
		this.LIST_ROLES_USER = user.roles;

		const permissionsToCheck = [this.MODIFY_INVENTORY_TAGS, this.MODIFY_INVENTORY_NOTE_QA];
		this.dungChungService.checkPermissions(permissionsToCheck).subscribe((result) => {
			this.permissionsSubject.next(result);
			this.changeDetectView();
		});
	}

	/*---------------------------- LOAD DATA --------------------------------*/
	ngOnInit() {
		this.CONFIG = new CommonConFig();
		this.CONFIG.PAGE_SIZE_LIST = environment.pageSize;
		this.screenHeight = window.innerHeight - 310;
		this.SHOW_BUTTON_SAVE.next(this.isTrueButton(this.MODIFY_INVENTORY_TAGS));
		this.SHOW_BUTTON_EDIT_GHICHU.next(this.isTrueButton(this.EDIT_GHICHU));
		this.tmpfilterText = Object.assign({}, this.filterText);
		this.showColumnsInTable();
		this.applySelectedColumns();
		this.ListTagKho();
		//this.ListId_HH();
		this.ListKho();
		this.ListIdHH();
		this.ListLoaiHH();
		this.haveFilter = true;
		this.filterText["TuNgay"] = "";
		this.filterText["DenNgay"] = "";
		this.disableButtonFilter["Tinhtrang"] = true;
		this.disableButtonFilter["MaKho"] = true;
		this.disableButtonFilter["MaHang"] = true;
		this.disableButtonFilter["Solo"] = true;
		this.disableButtonFilter["MaSub"] = true;
		this.dungChungService.listKho().subscribe((res) => {
			if (res && res.status === 1) {
				var i = 0;
				this.filterGroupDataChecked["MaKho"] = res.data.map((x) => {
					i = i + 1;
					return {
						id: i,
						name: x.MaKho + " - " + x.TenKho,
						value: x.Id_Kho,
						checked: false,
					};
				});
				this.filterGroupDataCheckedFake = Object.assign({}, this.filterGroupDataChecked);
			}
		});
		//Tag Kho
		this.dungChungService.getlistTagKhoForFilter().subscribe((res) => {
			if (res && res.status === 1) {
				var i = 0;
				this.filterGroupDataChecked["Tag"] = res.data.map((x) => {
					i = i + 1;
					return {
						id: i,
						name: x.tagkho,
						value: x.tagkho,
						checked: false,
					};
				});
				this.filterGroupDataCheckedFake = Object.assign({}, this.filterGroupDataChecked);
			}
		});
		var i = 0;
		this.filterGroupDataChecked["Tinhtrang"] = TonKhoHienTai.optionsTinhTrang.map((x) => {
			i = i + 1;
			return {
				id: i,
				name: x.name,
				value: x.value,
				checked: false,
			};
		});
		this.filterGroupDataCheckedFake = Object.assign({}, this.filterGroupDataChecked);

		merge(this.sort.sortChange)
			.pipe(
				tap(() => {
					this.loadListData();
				})
			)
			.subscribe();

		// // Set title to page breadCrumbs
		let breadcrumbs = [{ title: "Kho" }, { title: "Tồn kho hiện tại", page: "/ton-kho-hien-tai" }];
		this.subheaderService.setBreadcrumbs(breadcrumbs);

		// Init DataSource
		/*this.dataSource = new TonKhoHienTaiDataSource(this.tonKhoHienTaiService);
		this.dataSource.entitySubject.subscribe(res => {
			this.tonKhoHienTaiResult = res
			this.tmpTonKhoHienTaiResult = []
			this.isShow=false;
			this.changeDetectView();
			if(this.tonKhoHienTaiResult != null){
				for(let i = 0; i < this.tonKhoHienTaiResult.length; i++){
					if(!this.tonKhoHienTaiResult[i].TagInfo){
						this.tonKhoHienTaiResult[i].TagInfo = [];
					}
					let tmpElement = new TonKhoHienTai();
					tmpElement.copy(this.tonKhoHienTaiResult[i])
					this.tmpTonKhoHienTaiResult.push(tmpElement);
				}
				this.isShow=true;
			}
			this.isShowSpinner=false;
			this.changeDetectView();
		});*/
		// ..
		const resizeElement = document.querySelector(".mat-table__wrapper") as HTMLElement;
		if (!resizeElement) {
			throw new Error("Element with class 'mat-table__wrapper' not found");
		}

		const observeElementSize = () => {
			const rect = resizeElement.getBoundingClientRect();
			const width = rect.width;
			this.loadingWidth.next(width + "");
		};

		// Gọi hàm observeElementSize() khi trang được tải và khi cửa sổ thay đổi
		observeElementSize();
		window.addEventListener("resize", observeElementSize);
	}
	ngAfterViewInit() {}

	ngOnDestroy(): void {}

	@HostListener("window:resize", ["$event"])
	onResize(event) {
		this.screenHeight = window.innerHeight - 310;
	}
	loadListData() {
		this.isShowSpinner.next(true);
		this.selection.clear();
		this.PREV_PAGE = 0;
		this.CURRENT_PAGE = 1;
		const queryParams = new QueryParamsModel(this.filterConfiguration(), this.sort.direction, this.sort.active, this.CURRENT_PAGE, this.MAX_RECORD, this.filterGroupData, true);
		this.fullTonKhoHienTaiResult = [];
		this.tmpTonKhoHienTaiResult = [];
		this.tonKhoHienTaiService.get_current_inventory_data(queryParams).subscribe((response: any) => {
			this.fullTonKhoHienTaiResult = [...response.data];
			this.loadMoreData();
			this.isShowSpinner.next(false);
			this.changeDetectView();
		});
	}
	filterConfiguration(): any {
		const filter: any = {};
		filter.keywordSearch = this.keywordSearch.nativeElement.value;
		filter.listHH = this.selectId_HH;
		filter.listKho = this.selectKho;
		filter.listLoaiHH = this.selectLoaiHH;
		filter.getNonZeroWeight = this.selectNonZeroWeight ? "1" : "0";
		if (this.filterText) {
			filter.TenKho = this.filterText["TenKho"] == undefined ? "" : this.filterText["TenKho"];
			filter.MaHH = this.filterText["MaHH"] == undefined ? "" : this.filterText["MaHH"];
			filter.TenHH = this.filterText["TenHH"] == undefined ? "" : this.filterText["TenHH"];
			filter.Solo = this.filterText["Solo"] == undefined ? "" : this.filterText["Solo"];
			filter.SoMay = this.filterText["SoMay"] == undefined ? "" : this.filterText["SoMay"];
			filter.SoXeSoMe = this.filterText["SoXeSoMe"] == undefined ? "" : this.filterText["SoXeSoMe"];
			filter.MaThung = this.filterText["MaThung"] == undefined ? "" : this.filterText["MaThung"];
			filter.MaNCC = this.filterText["MaNCC"] == undefined ? "" : this.filterText["MaNCC"];
			filter.TenNCC = this.filterText["TenNCC"] == undefined ? "" : this.filterText["TenNCC"];
			filter.MaSub = this.filterText["MaSub"] == undefined ? "" : this.filterText["MaSub"];
			filter.TenDVT = this.filterText["TenDVT"] == undefined ? "" : this.filterText["TenDVT"];
			filter.ViTriKho = this.filterText["ViTriKho"] == undefined ? "" : this.filterText["ViTriKho"];
			filter.PalletText = this.filterText["PalletText"] == undefined ? "" : this.filterText["PalletText"];
			filter.TenNHH = this.filterText["TenNHH"] == undefined ? "" : this.filterText["TenNHH"];
			filter.TenLoaiHH = this.filterText["TenLoaiHH"] == undefined ? "" : this.filterText["TenLoaiHH"];
			filter.SoPhieu = this.filterText["SoPhieu"] == undefined ? "" : this.filterText["SoPhieu"];
			filter.LyDoKhongDuocXuat = this.filterText["LyDoKhongDuocXuat"] == undefined ? "" : this.filterText["LyDoKhongDuocXuat"];
			filter.TuNgay = this.filterText["TuNgay"] == "" ? "" : moment(new Date(this.filterText["TuNgay"])).format("DD/MM/YYYY");
			filter.DenNgay = this.filterText["DenNgay"] == "" ? "" : moment(new Date(this.filterText["DenNgay"])).format("DD/MM/YYYY");
		}
		return filter;
	}
	minMaxDate(p_Val: any, flag?: number) {
		if (flag == 0) {
			this.down = new Date(p_Val._d);
		} else {
			this.top = new Date(p_Val._d);
		}
	}
	clearMinMaxDate() {
		this.top = null;
		this.down = null;
		this.changeDetectView();
	}
	removeEl(fruit: string, index: number): void {
		let el = this.tmpTonKhoHienTaiResult[index];
		if (el) {
			let idx = el.TagInfo.indexOf(fruit);
			if (idx >= 0) {
				el.TagInfo.splice(idx, 1);
			}
		}
		this.changeDetectView();
	}
	selectedEl(event: MatAutocompleteSelectedEvent, index: number): void {
		let el = this.tmpTonKhoHienTaiResult[index];
		if (el && !el.TagInfo.includes(event.option.viewValue)) el.TagInfo.push(event.option.viewValue);
		this.changeDetectView();
	}
	filterSearch(event: any) {
		if (!event) return null;
		let value = event.target.value;
		if (value) {
			let newList = this.listTag.filter((tag) => tag.toLowerCase().indexOf(value.toLowerCase()) > -1);
			this.filteredTags.next(newList);
		} else {
			this.filteredTags.next(this.listTag.slice());
		}
		this.changeDetectView();
	}
	ChangeTag(item: TonKhoHienTai) {
		const dialogRef = this.layoutUtilsService.POPConfirm("Bạn chắc chắn muốn thay đổi thông tin Tag");
		dialogRef.afterClosed().subscribe((res) => {
			if (!res) return;

			let _requestBody = new UpdateTagInfoRequestBody();
			_requestBody.clear();
			_requestBody.InventoriesId = [item.IdTk];
			_requestBody.TagInfo = item.TagInfo;

			this.tonKhoHienTaiService.ChangeTag(_requestBody).subscribe((res) => {
				if (res.status == 1) {
					this.layoutUtilsService.showInfo("Tag cập nhật thành công");
					return;
				}
				this.layoutUtilsService.showErorr(res.error.message);
			});
		});
	}
	UpdateInventoriesTag() {
		if (this.positionInvPasteTag.length == 0 || this.processSaveTag.value) return;

		const popupIndex = this.isCopyTag ? TonKhoHienTai.INDEX_TAG : this.isCopyNoteQA ? TonKhoHienTai.INDEX_NOTE_QA : -1;
		const popupAction = TonKhoHienTai.POPUP_MULTIPLE[popupIndex].Popup;
		const confirmMessage = `Bạn chắc chắn muốn cập nhật thông tin ${popupAction} vào các dòng đã chọn`;
		const dialogRef = this.layoutUtilsService.POPConfirm(confirmMessage);
		dialogRef.afterClosed().subscribe((result) => {
			if (!result) return;

			if (this.isCopyTag) {
				const requestBody = new UpdateTagInfoRequestBody();
				requestBody.clear();
				requestBody.InventoriesId = this.positionInvPasteTag;
				requestBody.TagInfo = this.dataCopyTag;

				this.processSaveTag.next(true);
				this.tonKhoHienTaiService.ChangeTag(requestBody).subscribe((response) => {
					this.processSaveTag.next(false);
					if (response && response.status == 1) {
						this.layoutUtilsService.showInfo("Tag cập nhật thành công");
						this.isCopyTag = TonKhoHienTai.COPYTAG.FALSE;
						this.isCheckedAll = TonKhoHienTai.CHECKALL.FALSE;
						this.dataCopyTag = [];
						this.positionInvPasteTag = [];
						this.loadListData();
						return;
					}
					this.layoutUtilsService.showErorr(response.error.message);
				});
			}

			if (this.isCopyNoteQA) {
				const requestBody = new UpdateNoteQARequestBody();
				requestBody.clear();
				requestBody.InventoriesId = this.positionInvPasteTag;
				requestBody.NoteQA = (this.dataCopyNoteQA || "").trim();

				this.processSaveTag.next(true);
				this.tonKhoHienTaiService.ChangeGhiChu(requestBody).subscribe((response) => {
					this.processSaveTag.next(false);
					if (response && response.status == 1) {
						this.layoutUtilsService.showInfo("Ghi chú QA cập nhật thành công");
						this.isCopyNoteQA = TonKhoHienTai.COPYNOTEQA.FALSE;
						this.isCheckedAll = TonKhoHienTai.CHECKALL.FALSE;
						this.dataCopyNoteQA = "";
						this.positionInvPasteTag = [];
						this.loadListData();
						return;
					}
					this.layoutUtilsService.showErorr(response.error.message);
				});
			}
		});
	}
	ChangeGhiChu(item) {
		const dialogRef = this.layoutUtilsService.POPConfirm("Bạn chắc chắn muốn thay đổi thông tin ghi chú");

		dialogRef.afterClosed().subscribe((res) => {
			if (!res) {
				return;
			}

			let _requestBody = new UpdateNoteQARequestBody();
			_requestBody.clear();
			_requestBody.InventoriesId = [item.IdTk];
			_requestBody.NoteQA = item.Ghichu;

			this.tonKhoHienTaiService.ChangeGhiChu(_requestBody).subscribe((res) => {
				if (res.status == 1) {
					this.layoutUtilsService.showInfo("Ghi chú cập nhật thành công");
				} else {
					this.layoutUtilsService.showErorr(res.error.message);
				}
			});
		});
	}
	/* -----------------------------------------------------------------------*/
	ExportExcelJs() {
		const queryParams = new QueryParamsModel(this.filterConfiguration(), this.sort.direction, this.sort.active, this.CURRENT_PAGE, this.MAX_RECORD, this.filterGroupData, true);
		if (queryParams.filter.TuNgayTonKho > queryParams.filter.DenNgayTonKho) {
			const message = `Từ ngày phải nhỏ hoặc bằng đến ngày`;
			this.layoutUtilsService.showErorr(message);
			return;
		}

		queryParams.type = "TonKhoHienTai";
		this.dungChungService.XuatExcelTonKho(queryParams).subscribe((res) => {
			if (res && res.success) {
				const message = `Yêu cầu xuất file thành công. Vui lòng kiểm tra menu Cấu hình/Danh sách xuất file sau ít phút.`;
				this.layoutUtilsService.showInfo(message);
			} else {
				const message = `Yêu cầu xuất file có lỗi, vui lòng thử lại!`;
				this.layoutUtilsService.showErorr(message);
			}
			return;
		});
	}
	getTotalNumber() {
		let total = 0;
		this.fullTonKhoHienTaiResult.forEach((element) => {
			total += Number(element.Soluong);
		});
		return this.f_currency(this.formatNumber(total.toString()));
	}
	/*------------------------- CÁC THAO TÁC TRÊN FORM ----------------------*/
	/* -----------------------------------------------------------------------*/

	/*------------------------ CÁC HÀM XÁC NHẬN CẤP QUYỀN ---------------------*/
	// isTrueButton(ROLENUMBER: number){
	// 	if(this.LIST_ROLES_USER.findIndex(x => x == ROLENUMBER) > -1){
	// 		return true;
	// 	}
	// 	return false;
	// }
	isTrueButton(ROLENUMBER: string) {
		if (this.LIST_ROLES_USER.findIndex((x) => x == ROLENUMBER) > -1) {
			return true;
		}
		return false;
	}
	/* -----------------------------------------------------------------------*/

	/*----------------------- Load Danh sách Dropdown --------------------*/
	ListId_HH() {
		this.tonKhoHienTaiService.listHangHoa().subscribe((res) => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listId_HH = res.data;
				this.filteredId_HH.next(this.listId_HH.slice());
				this.changeDetect.detectChanges();
			}
		});
	}
	filterId_HH(searchTmp: string = "") {
		if (!this.listId_HH) {
			return;
		}
		// get the search keyword
		let search = this.Id_HHFilterCtrl;
		if (searchTmp != "") search = "" + searchTmp;

		if (!search) {
			this.filteredId_HH.next(this.listId_HH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}

		if (searchTmp != "") {
			this.filteredId_HH.next(this.listId_HH.filter((ts) => ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1));
		} else {
			this.filteredId_HH.next(this.listId_HH.filter((ts) => ts.MaHH.toLowerCase().indexOf(search) > -1));
		}

		this.changeDetect.detectChanges();
	}
	SelectId_HH(event: any, dependOnField: string = "") {
		if (this.selectId_HH.length >= 0 && event.length > 0) this.haveElementId_HH = true;
		if (this.selectId_HH.length <= 1 && event.length == 0) this.haveElementId_HH = false;
		if (dependOnField != "") {
		}
	}
	ClearId_HH(event: any) {
		this.selectId_HH = [];
		this.haveElementId_HH = false;
		event.stopPropagation();
	}

	ListKho() {
		this.tonKhoHienTaiService.listKho().subscribe((res) => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listKho = res.data;
				this.filteredKho.next(this.listKho.slice());
				this.changeDetect.detectChanges();
			}
		});
	}
	filterListKho() {
		if (!this.listKho) {
			return;
		}
		// get the search keyword
		let search = this.KhoFilterCtrl;
		if (!search) {
			this.filteredKho.next(this.listKho.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredKho.next(this.listKho.filter((ts) => ts.TenKho.toLowerCase().indexOf(search) > -1));
		this.changeDetect.detectChanges();
	}
	SelectListKho(event: any, dependOnField: string = "") {
		if (this.selectKho.length >= 0 && event.length > 0) this.haveElementKho = true;
		if (this.selectKho.length <= 1 && event.length == 0) this.haveElementKho = false;
		if (dependOnField != "") {
		}
	}
	ClearListKho() {
		this.selectKho = [];
		this.haveElementKho = false;
		this.ListIdHH();
		event.stopPropagation();
	}
	/* -----------------------------------------------------------------------*/

	/*----------------------- CSS HIỂN THỊ CHO TRẠNG THAI --------------------*/
	getItemStatusString(status: any): string {
		switch (status) {
			case false:
				return "Không cho phép xuất";
			case true:
				return "Cho phép xuất";
		}
		return "";
	}
	getItemCssClassByStatus(status: any): string {
		switch (status) {
			case true:
				return "_hoantat";
			case false:
				return "_dahuy";
		}
	}
	/* -----------------------------------------------------------------------*/

	/* -----------------------------------------------------------------------*/

	/*-------------------- HÀM HỖ TRỢ FORMAT DẠNG SỐ -----------------------*/
	ValidateChangeNumberEvent(columnName: string, item: any, event: any) {
		var count = 0;
		for (let i = 0; i < event.target.value.length; i++) {
			if (event.target.value[i] == ".") {
				count += 1;
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = "Dữ liệu không gồm chữ hoặc kí tự đặc biệt";
			this.layoutUtilsService.showActionNotification(message, MessageType.Create, 3000, true, false);
			return false;
		}
		if (count >= 2) {
			const message = "Dữ liệu không thể có nhiều hơn 2 dấu .";
			this.layoutUtilsService.showActionNotification(message, MessageType.Create, 3000, true, false);
			return false;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == "" || item == null || item == undefined) return "";
		return Number(Math.round(parseFloat(item + "e" + this.fixedPoint)) + "e-" + this.fixedPoint).toFixed(this.fixedPoint);
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == "") value = "0.00";
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + "").replace(/,/g, ""));
		return (nbr + "").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), this.fixedPoint + 1);
	}
	f_currency_V2(value: string): any {
		if (value == null || value == undefined || value == "") return "";
		let nbr = Number((value + "").replace(/,/g, ""));
		return (nbr + "").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	lpad(value, padding) {
		var zeroes = new Array(padding + 1).join("0");
		return (zeroes + value).slice(-padding);
	}
	/* -----------------------------------------------------------------------*/

	/*-------------------- HÀM HỖ TRỢ FORMAT DẠNG NGÀY -----------------------*/
	getFormatDate(v: string = "") {
		if (v && v != "") {
			return v.includes("T") ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return "";
	}
	formatDate(date) {
		return moment(date).format("DD/MM/YYYY");
	}
	f_convertDate(p_Val: any) {
		if (p_Val == null || p_Val == undefined || p_Val == "") return "";
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + a.getDate()).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	getFirstDay_LastDay(b_firstday) {
		var date = new Date(),
			y = date.getFullYear(),
			m = date.getMonth();
		var firstDay = new Date(y, m, 1);
		var lastDay = new Date(y, m + 1, 0);
		var curent = new Date();
		return b_firstday ? this.datePipe.transform(firstDay, "dd/MM/yyyy") : this.datePipe.transform(curent, "dd/MM/yyyy");
	}
	/* -----------------------------------------------------------------------*/

	/* ---------- HÀM HỖ TRỢ HIỂN THỊ CỘT TRÊN MENU --------------------------*/
	IsAllColumnsChecked() {
		const numSelected = this.selectedColumns.selected.length;
		const numRows = this.availableColumns.length;
		return numSelected === numRows;
	}
	CheckAllColumns() {
		if (this.IsAllColumnsChecked()) {
			this.availableColumns.forEach((row) => {
				if (!row.alwaysChecked) this.selectedColumns.deselect(row);
			});
		} else {
			this.availableColumns.forEach((row) => this.selectedColumns.select(row));
		}
	}
	menuChange(e: any, type: 0 | 1 = 0) {
		this.layoutUtilsService.menuSelectColumns_On_Off();
	}
	/*----------------------------------------------------------------------- */

	/*-------- CÁC HÀM HỖ TRỢ CHUYỂN CỘT VÀ HIỂN THỊ CỘT TRONG BẢNG ----------*/
	showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column) return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach((col) => {
			_applySelectedColumns.push(col.name);
		});
		this.displayedColumns = _applySelectedColumns;
	}
	/*----------------------------------------------------------------------- */

	/*-----------------------------FILTER ON GRID ----------------------------*/
	removeText(col) {
		this.filterText[col] = "";
		this.loadListData();
	}
	/* ---------------------------------------------------------------------- */
	//#region Filter function
	SelectAll(event, col) {
		if (event.checked) {
			this.filterGroupDataCheckedFake[col].forEach((element) => {
				element.checked = true;
			});
		} else {
			this.filterGroupDataCheckedFake[col].forEach((element) => {
				element.checked = false;
			});
		}
	}
	isColumnSelectAll(col) {
		if (this.filterGroupDataCheckedFake[col]) {
			let lst_checked = this.filterGroupDataCheckedFake[col].filter((opt) => opt.checked).map((opt) => opt.value);
			if (lst_checked) {
				if (lst_checked.length != this.filterGroupDataCheckedFake[col].length) {
					return false;
				} else {
					return true;
				}
			} else {
				return false;
			}
		}
		return false;
	}
	LoadDataDropFilter(col) {
		this.tmpfilterText = Object.assign({}, this.filterText);
		if (this.filterGroupDataChecked && this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col] && this.filterGroupDataChecked[col]) {
			this.filterGroupDataCheckedFake[col] = this.filterGroupDataChecked[col].map((x) => Object.assign({}, x));
		}
	}
	// isSelect : true list chon | false là nhap text
	disableDoneButton(col, isSelect = true) {
		let countChecked = 0;

		if (isSelect) {
			if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
				for (var elementFake of this.filterGroupDataCheckedFake[col]) {
					if (elementFake.checked) {
						countChecked++;
					}
				}
			}
			if (countChecked > 0) {
				this.disableButtonFilter[col] = false;
			} else {
				this.disableButtonFilter[col] = true;
			}
		} else {
			if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
				if (this.filterGroupDataCheckedFake[col].length > 0) {
					this.disableButtonFilter[col] = false;
				} else {
					this.disableButtonFilter[col] = true;
				}
			}
		}
	}
	showClearAllButton() {
		let _count = 0;
		for (var key in this.filterGroupArray) {
			if (this.filterGroupArray.hasOwnProperty(key)) {
				if (this.filterGroupArray[key]) {
					let _arrflt = this.filterGroupArray[key].filter((opt) => opt.checked);
					_count += _arrflt ? _arrflt.length : 0;
				}
			}
		}
		let _text = "";
		for (var key in this.filterText) {
			if (this.filterText.hasOwnProperty(key)) {
				_text += this.filterText[key];
			}
		}
		if (_count > 0 || _text) {
			this.isClearAll = true;
		} else {
			this.isClearAll = false;
		}
		this.changeDetect.detectChanges();
	}
	filterHead(col) {
		if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
			for (var elementFake of this.filterGroupDataCheckedFake[col]) {
				let index = this.filterGroupDataChecked[col].findIndex((x) => x.id == elementFake.id);

				if (index > -1) this.filterGroupDataChecked[col][index].checked = elementFake.checked;
			}
			this.filterGroupData[col] = [];
			this.filterGroupArray[col] = [];
			this.filterGroupArray[col] = this.filterGroupDataCheckedFake[col].filter((opt) => opt.checked);
			this.filterGroupData[col] = this.filterGroupDataCheckedFake[col].filter((opt) => opt.checked).map((op) => op.value);

			this.filterGroupDataCheckedFake[col] = this.filterGroupDataChecked[col].map((x) => Object.assign({}, x));
			this.tmpfilterText[col] = "";
		}
		this.filterText = Object.assign({}, this.tmpfilterText);
		if (this.filterText) {
			this.filterConfiguration();
		}
		this.isClearAll = this.checkFilterHasValue(this.filterGroupDataChecked, "ALL");
		this.loadListData();
	}
	remove(item, col, isSelect = true) {
		let _indexX = this.filterGroupDataCheckedFake[col].findIndex((x) => x.name == item.name);
		let _indexY = this.filterGroupDataChecked[col].findIndex((x) => x.name == item.name);
		if (_indexX > -1) {
			this.filterGroupDataCheckedFake[col][_indexX].checked = false;
			this.filterGroupDataChecked[col][_indexY].checked = false;
			this.filterGroupData[col] = [];
			this.filterGroupArray[col] = [];
			this.filterGroupArray[col] = this.filterGroupDataCheckedFake[col].filter((opt) => opt.checked);
			this.filterGroupData[col] = this.filterGroupDataCheckedFake[col].filter((opt) => opt.checked).map((op) => op.value);

			if (this.filterGroupDataCheckedFake[col].filter((x) => x.checked).length == 0) {
				this.tmpfilterText[col] = "";
				this.filterText[col] = "";

				for (let index = 0; index < this.filterGroupDataChecked[col].length; index++) {
					const element = this.filterGroupDataChecked[col][index];
					element.checked = false;
				}
				this.filterGroupDataCheckedFake[col] = [];
				this.filterGroupDataChecked[col].forEach((x) => this.filterGroupDataCheckedFake[col].push(Object.assign({}, x)));
				this.disableButtonFilter[col] = true;
			}
			this.loadListData();
		}
	}
	Clear() {
		this.filterGroupData = [];
		this.filterGroupArray = [];
		for (var key in this.filterGroupDataChecked) {
			if (this.filterGroupDataChecked.hasOwnProperty(key)) {
				if (this.filterGroupDataChecked[key]) {
					this.filterGroupDataChecked[key].forEach((element) => {
						element.checked = false;
					});
				}
			}
		}
		for (var key in this.filterGroupDataCheckedFake) {
			if (this.filterGroupDataCheckedFake.hasOwnProperty(key)) {
				if (this.filterGroupDataCheckedFake[key]) {
					this.filterGroupDataCheckedFake[key].forEach((element) => {
						element.checked = false;
					});
				}
			}
		}
		this.filterGroupDataCheckedFake = {};
		this.filterGroupDataCheckedFake = Object.assign({}, this.filterGroupDataChecked);
		for (var key in this.filterText) {
			if (this.filterText.hasOwnProperty(key)) {
				this.filterText[key] = "";
			}
		}
		for (var key in this.tmpfilterText) {
			if (this.tmpfilterText.hasOwnProperty(key)) {
				this.tmpfilterText[key] = "";
			}
		}
		this.loadListData();
		this.isClearAll = false;
		this.changeDetect.detectChanges();
	}
	checkFilterHasValue(data, col, isSelect = true) {
		let _count = 0;
		if (isSelect) {
			if (col == "ALL" && data) {
				//check all column
				for (var key in data) {
					if (data.hasOwnProperty(key)) {
						if (data[key]) {
							let _arrflt = data[key].filter((opt) => opt.checked);
							_count += _arrflt ? _arrflt.length : 0;
						}
					}
				}
				let _text = "";
				for (var key in this.filterText) {
					if (this.filterText.hasOwnProperty(key)) {
						_text += this.filterText[key];
					}
				}
				if (_count > 0 || _text) {
					return true;
				}
			} else {
				//check in 1 column
				if (data && data[col]) {
					let _arrflt = data[col].filter((opt) => opt.checked);
					_count += _arrflt ? _arrflt.length : 0;
				}
				if (_count > 0) {
					return true;
				}
			}
		} else {
			if (data && data[col] && data[col].length > 0) {
				if (data[col].length > 0) {
					return true;
				}
			}
		}
		return false;
	}
	filterGroupWithTextFilter(columnName: string) {
		let search = this.tmpfilterText[columnName];
		let arraytemp = [];
		if (!search) {
			if (this.filterGroupDataCheckedFake[columnName].length > 0) {
				for (let index = 0; index < this.filterGroupDataChecked[columnName].length; index++) {
					const elementX = this.filterGroupDataChecked[columnName][index];
					for (let index = 0; index < this.filterGroupDataCheckedFake[columnName].length; index++) {
						const elementY = this.filterGroupDataCheckedFake[columnName][index];
						if (elementX.value == elementY.value && elementY.checked) {
							elementX.checked = true;
						} else if (!elementY.checked && elementX.value == elementY.value) {
							elementX.checked = elementY.checked;
						}
					}
				}
			}
			this.filterGroupDataCheckedFake[columnName] = [];
			this.filterGroupDataChecked[columnName].forEach((x) => this.filterGroupDataCheckedFake[columnName].push(Object.assign({}, x)));
			this.disableButtonFilter[columnName] = this.checkStatuschecked(this.filterGroupDataCheckedFake[columnName]);
			this.changeDetect.detectChanges();
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filterGroupDataChecked[columnName].filter((x) => (x.name.toLowerCase().indexOf(search) > -1 ? arraytemp.push(Object.assign({}, x)) : x));
		if (arraytemp.length > 0) {
			for (let indexX = 0; indexX < this.filterGroupDataCheckedFake[columnName].length; indexX++) {
				const elementX = this.filterGroupDataCheckedFake[columnName][indexX];
				for (let indexY = 0; indexY < arraytemp.length; indexY++) {
					const elementY = arraytemp[indexY];
					if (elementX.checked && elementX.value == elementY.value) {
						elementY.checked = elementX.checked;
					} else if (!elementX.checked && elementX.value == elementY.value) {
						elementY.checked = elementX.checked;
					}
				}
			}
			this.filterGroupDataCheckedFake[columnName] = [];
			this.filterGroupDataCheckedFake[columnName] = arraytemp;
			for (let index = 0; index < this.filterGroupDataChecked[columnName].length; index++) {
				const elementX = this.filterGroupDataChecked[columnName][index];
				for (let index = 0; index < this.filterGroupDataCheckedFake[columnName].length; index++) {
					const elementY = this.filterGroupDataCheckedFake[columnName][index];
					if (elementX.value == elementY.value && elementY.checked) {
						elementX.checked = elementY.checked;
					} else if (!elementY.checked && elementX.value == elementY.value) {
						elementX.checked = elementY.checked;
					}
				}
			}
			this.changeDetect.detectChanges();
		} else {
			for (let index = 0; index < this.filterGroupDataChecked[columnName].length; index++) {
				const elementX = this.filterGroupDataChecked[columnName][index];
				for (let index = 0; index < this.filterGroupDataCheckedFake[columnName].length; index++) {
					const elementY = this.filterGroupDataCheckedFake[columnName][index];
					if (elementX.value == elementY.value && elementY.checked) {
						elementX.checked = elementY.checked;
					} else if (!elementY.checked && elementX.value == elementY.value) {
						elementX.checked = elementY.checked;
					}
				}
			}
			this.filterGroupDataCheckedFake[columnName] = [];
		}
		this.disableButtonFilter[columnName] = this.checkStatuschecked(this.filterGroupDataCheckedFake[columnName]);
		this.changeDetect.detectChanges();
	}
	//check status checkbox
	checkStatuschecked(data) {
		let countchecked = data.filter((x) => x.checked);
		return countchecked.length > 0 ? false : true;
	}
	//#endregion Filter function

	ListIdHH() {
		let queryParam = new QueryParamsModel({});
		queryParam.filterGroup.IdKho = this.selectKho;
		queryParam.filterGroup.IdLoai = this.selectLoaiHH;
		this.loadDropdownProduct.next(true);
		this.dungChungService.layDanhSachHHDaNhapKho(queryParam).subscribe((res) => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listIdHH = res.data;
				this.filteredIdHH.next(this.listIdHH.slice());
				this.loadDropdownProduct.next(false);
				if (this.selectId_HH && this.selectId_HH.length > 0) {
					this.selectId_HH = this.listIdHH.map((_x) => _x.IdHh).filter((_x) => this.selectId_HH.indexOf(_x.toString()) > -1);
				}
				this.changeDetect.detectChanges();
			}
			this.loadDropdownProduct.next(false);
		});
	}
	filterIdHH() {
		if (!this.listIdHH) {
			return;
		}
		// get the search keyword
		let search = this.IdHHFilterCtrl;
		if (!search) {
			this.filteredIdHH.next(this.listIdHH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredIdHH.next(this.listIdHH.filter((ts) => (ts.Mahh + " - " + ts.Tenhh).toLowerCase().indexOf(search) > -1));
		this.changeDetect.detectChanges();
	}

	clearHH() {
		this.selectId_HH = [];
		this.selectNonZeroWeight = false;
		this.changeDetect.detectChanges();
	}

	XuatThongKeTonKho() {
		setTimeout(() => {
			//this.isShowSpinner=true;
			this.changeDetectView();
		}, 100);

		const queryParams = new QueryParamsModel(this.filterConfiguration(), this.sort.direction, this.sort.active, 0, 10, this.filterGroupData, true);

		this.tonKhoHienTaiService.XuatExcelTongHopTonKhoHT(queryParams);

		this.tonKhoHienTaiService.lastExportDataFile.subscribe((res) => {
			if (res) {
				//this.isShowSpinner=false;
				this.changeDetectView();
			}
		});
	}

	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges();
		}
	}

	ListTagKho() {
		this.dungChungService.listTagKho().subscribe((res) => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listTagFull = res.data;
				this.listTag = res.data.map((x) => x.tagkho);
				this.filteredTags.next(this.listTag.slice());
				this.changeDetectView();
			}
		});
	}

	// .. Hàm lấy mã màu từ tên tag kho
	getBgColorTag(tag: string) {
		var _item = this.listTagFull.find((_x) => _x.tagkho == tag);
		return _item == null ? "#cccccc" : _item.BackgroundColor;
	}
	ListLoaiHH() {
		this.dungChungService.listLoaiHH().subscribe((res) => {
			// this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listLoaiHH = res.data;
				this.filteredLoaiHH.next(this.listLoaiHH.slice());
				var index = 0;
				this.filterGroupDataChecked["TenLoaiHH"] = this.listLoaiHH.map((a) => {
					index = index + 1;
					return {
						id: index,
						name: a.TenLoaiHH,
						value: a.TenLoaiHH,
						checked: false,
					};
				});
				this.filterGroupDataCheckedFake = Object.assign({}, this.filterGroupDataChecked);
				this.changeDetect.detectChanges();
			}
		});
	}
	//================================================================================
	onScroll() {
		const listContainer = this.listContainer.nativeElement;
		const loadSuccess = this.fullTonKhoHienTaiResult.length === this.tmpTonKhoHienTaiResult.length;

		const scrolledToBottom = listContainer.scrollTop + listContainer.clientHeight >= listContainer.scrollHeight - 300;
		const shouldLoadMore = this.CURRENT_PAGE !== this.PREV_PAGE && scrolledToBottom && !loadSuccess;

		if (shouldLoadMore) {
			this.isLoadMoreSpinner.next(true);
			this.loadMoreData();
			this.changeDetectView();
		}
	}

	loadMoreData() {
		const lastIndex = this.CURRENT_PAGE * this.MAX_RECORD;
		const firstIndex = this.PREV_PAGE * this.MAX_RECORD;
		const loadMore = this.fullTonKhoHienTaiResult.slice(firstIndex, lastIndex);

		this.tmpTonKhoHienTaiResult = [...this.tmpTonKhoHienTaiResult, ...loadMore];
		this.PREV_PAGE = this.CURRENT_PAGE;
		this.CURRENT_PAGE++;

		setTimeout(() => {
			if (this.isCheckedAll) {
				const inventoriesIdLoadMore = loadMore.map((x) => x.IdTk);
				this.positionInvPasteTag = [...this.positionInvPasteTag, ...inventoriesIdLoadMore];
			}
			this.isLoadMoreSpinner.next(false);
			this.changeDetectView();
		}, 300);
	}
	// .. Xuất excel
	exportToExcel() {
		this.isExportExcel.next(true);
		this.selection.clear();
		const queryParams = new QueryParamsModel(this.filterConfiguration(), this.sort.direction, this.sort.active, this.CURRENT_PAGE, this.MAX_RECORD, this.filterGroupData, true);
		this.tonKhoHienTaiService.export_current_inventory_data(queryParams).subscribe({
			next: (blob) => {
				const url = URL.createObjectURL(blob);
				const currentDate = new Date();
				const formattedDate = currentDate.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" }).replace(/\//g, "-");
				const formattedTime = currentDate.toLocaleTimeString("en-US", { hour12: false, hour: "2-digit", minute: "2-digit" }).replace(/:/g, "");
				//const fileName = `ThongKeTonKho${formattedDate}_${formattedTime}.xlsx`;
				const fileName = `Tồn kho hiện tại.xlsx`;
				const downloadLink = document.createElement("a");
				downloadLink.href = url;
				downloadLink.download = fileName;
				document.body.appendChild(downloadLink);
				downloadLink.click();
				document.body.removeChild(downloadLink);
				URL.revokeObjectURL(url); // Clean up to release resources
				this.handleExportExcelComplete();
			},
			error: (err) => {
				console.error("Failed to download file:", err);
				this.handleExportExcelComplete();
			},
		});
	}

	handleExportExcelComplete() {
		this.isExportExcel.next(false);
		this.changeDetectView();
	}

	f_number(item: any = "0.00000") {
		return FunctionPublic.F_NUMBER_DYNAMIC(item, 5);
	}

	filterLoaiHH() {
		let search = this.LoaiHHFilterCtrl;
		if (!this.listLoaiHH) return;
		if (!search) {
			this.filteredLoaiHH.next(this.listLoaiHH.slice());
			return;
		}
		search = search.toLowerCase().trim();
		this.filteredLoaiHH.next(this.listLoaiHH.filter((ts) => ts.TenLoaiHH.toLowerCase().indexOf(search) > -1));
		this.changeDetect.detectChanges();
	}

	clearLoaiHH() {
		this.selectLoaiHH = [];
		this.ListIdHH();
		this.changeDetect.detectChanges();
	}

	getCurrentInventoriesDataDetails(currentInventoryId: number) {
		this.tonKhoHienTaiService.get_current_inventory_data_histories(currentInventoryId).subscribe((response) => {
			if (response && response.status == 1) {
				if (!response.data || response.data.length == 0) {
					this.layoutUtilsService.showInfo("Không có dữ liệu lịch sử thay đổi thông tin!");
					return;
				}
				const dialogRef = this.dialog.open(TonKhoHienTaiHistoriesComponent, {
					data: response.data,
					height: "90vh",
					width: "98vw",
				});
				dialogRef.afterClosed().subscribe((res) => {});
			} else {
				this.layoutUtilsService.showErorr("Lỗi: Không thể tải lịch sử thay đổi thông tin!");
			}
		});
	}

	onCheckboxChange(event) {
		if (event.checked && this.selectId_HH.length == 0) {
			this.layoutUtilsService.showErorr("Vui lòng chọn mặt hàng cần xem");
			event.source.checked = !event.checked;
			return;
		}
	}

	selectedProducts() {
		if (this.selectId_HH.length == 0) {
			this.selectNonZeroWeight = false;
			this.changeDetectView();
		}
	}

	/**
	 * Mở popup chọn tags
	 */
	showPopupCopyMultiple(popupCode) {
		let tags = this.listTag;
		let infoTags = this.listTagFull;
		let infoPopup = TonKhoHienTai.POPUP_MULTIPLE.find((p) => p.Code == popupCode);
		const dialogRef = this.dialog.open(TonKhoHienTaiPopUpComponent, {
			data: { popupCode, tags, infoTags },
			width: "440px",
		});
		dialogRef.afterClosed().subscribe((res) => {
			const haveResponse = res;

			if (infoPopup.Code == TonKhoHienTai.POPUP_MULTIPLE[TonKhoHienTai.INDEX_TAG].Code) {
				this.isCopyTag = haveResponse.data;
				this.isCheckedAll = TonKhoHienTai.CHECKALL.FALSE;
				this.dataCopyTag = haveResponse ? res.data : [];
			}

			if (infoPopup.Code == TonKhoHienTai.POPUP_MULTIPLE[TonKhoHienTai.INDEX_NOTE_QA].Code) {
				this.isCopyNoteQA = haveResponse.data;
				this.isCheckedAll = TonKhoHienTai.CHECKALL.FALSE;
				this.dataCopyNoteQA = haveResponse ? res.data : "";
			}

			if (haveResponse) {
				this.layoutUtilsService.showInfo(infoPopup.AlertInfo);
				this.changeDetectView();
			}
		});
	}

	/**
	 * Hủy sao chép tags
	 */
	cancelPasteTag() {
		const dialogRef = this.layoutUtilsService.POP04_DanhMuc();
		dialogRef.afterClosed().subscribe((res) => {
			if (!res) return;
			this.isCopyTag = TonKhoHienTai.COPYTAG.FALSE;
			this.isCheckedAll = TonKhoHienTai.CHECKALL.FALSE;
			this.dataCopyTag = [];
			this.isCopyNoteQA = TonKhoHienTai.COPYNOTEQA.FALSE;
			this.dataCopyNoteQA = "";
			this.positionInvPasteTag = [];
			this.changeDetectView();
		});
	}

	/**
	 * Chọn tồn kho hiện tại nhận tag
	 * @param event
	 * @param inventoryId: number
	 */
	selectedInvPasteTag(event, inventoryId) {
		if (event.checked) {
			this.positionInvPasteTag.push(Number(inventoryId));
			this.positionInvPasteTag = [...this.positionInvPasteTag];
			this.changeDetectView();
			return;
		}
		this.positionInvPasteTag = [...this.positionInvPasteTag.filter((item) => item != Number(inventoryId))];
		this.changeDetectView();
	}

	/**
	 * Tick all tag
	 * @param event
	 */
	onToggleTag(event) {
		if (!event.checked) {
			this.positionInvPasteTag = [];
			this.isCheckedAll = TonKhoHienTai.CHECKALL.FALSE;
			this.changeDetectView();
			return;
		}
		const inventoriesId = this.tmpTonKhoHienTaiResult.map((x) => x.IdTk);
		this.positionInvPasteTag = [...inventoriesId];
		this.isCheckedAll = TonKhoHienTai.CHECKALL.TRUE;
		this.changeDetectView();
	}

	/**
	 * Tag Checked
	 */
	onTagChecked(inventoryId: number) {
		return this.positionInvPasteTag.indexOf(inventoryId) > -1;
	}

	/**
	 * Kiểm tra check all
	 */
	onSelectedAll() {
		const selected = this.positionInvPasteTag.length;
		const details = this.tmpTonKhoHienTaiResult.length;
		return selected == details;
	}

	/**
	 * Kiểm tra đã có bất kì check chọn nào
	 */
	onHasValue() {
		return this.positionInvPasteTag.length > 0;
	}

  calculateRemainingDatePercentage(item: any) {
    if (!item.HanSuDungStr || !item.NgaySanXuatStr) {
      return 0;
    }

    const currentDate = new Date();
    const expirationDateParts = item.HanSuDungStr.split('/');
    const expirationDate = new Date(expirationDateParts[2], expirationDateParts[1] - 1, expirationDateParts[0]);
    const productionDateParts = item.NgaySanXuatStr.split('/');
    const productionDate = new Date(productionDateParts[2], productionDateParts[1] - 1, productionDateParts[0]);
    const timeDiff = currentDate.getTime() - productionDate.getTime();
    const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24)); 
    const monthsDiff = (expirationDate.getFullYear() - productionDate.getFullYear()) * 12 + (expirationDate.getMonth() - productionDate.getMonth());

    if (monthsDiff <= 0) {
      return 0;
    }

    const percentage = (1 - daysDiff/(monthsDiff * 30)) * 100;
    return Math.round(Math.max(0, Math.min(100, percentage)) * 100) / 100;
  }
}
